<template>
    <div class="messageBox">
        <avue-crud :data="data" :option="option" :page.sync="page"  @current-change="currentChange">
            <template slot="is_read" slot-scope="scope" >
                <span v-if="scope.row.is_read==1">是</span>
                <span v-else-if="scope.row.is_read==2">否</span>
            </template>
            <template slot="menu" slot-scope="scope" >
                <el-button type="primary" @click="readBtn(scope.row)" :disabled="scope.row.is_read==1">确认已读</el-button>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { confirmationMessage, insuranceMessageList } from '../../../api/insure';

    export default {
        name: 'insuranceMessage',
        inject:['reload'],
        data(){
            return{
                page:{
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                data: [],
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'消息ID',
                            prop:'id'
                        }, {
                            label:'消息标题',
                            prop:'title'
                        }, {
                            label:'消息内容',
                            prop:'content'
                        }, {
                            label:'是否已读',
                            prop:'is_read'
                        }, {
                            label:'发布时间',
                            prop:'create_time'
                        },
                    ]
                },
            }
        },
        methods:{
            //分页
            currentChange(num){
                insuranceMessageList(10,num).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('message',num)
                        this.data=res.data.list
                        this.page.total=res.data.count
                    }
                })
            },
            //确认已读
            readBtn(row){
                confirmationMessage({msg_id:row.id}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            let messageNum=Number(sessionStorage.getItem('message'))
            if (messageNum==0){
                insuranceMessageList(10,1).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
            }else {
                insuranceMessageList(10,messageNum).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=messageNum
                    }
                })
            }

        }
    };
</script>

<style scoped>
    .messageBox{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
</style>
